import React, { Fragment } from "react";
//Material imports
import PortalHelpIcon from "@mui/icons-material/HelpOutline";
//Limitless imports
import { HeaderIconButton, useHelpDrawer, PortalHelp, usePortalHelp } from "@limitless/portal";
const PortalHelpHeaderItem = () => {
  const {
    toggleHelpDrawer
  } = useHelpDrawer();
  const {
    isHelpAvailable
  } = usePortalHelp();
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "portalHelpButton",
    onButtonClick: toggleHelpDrawer,
    tooltip: isHelpAvailable ? "Portal Help" : "Portal Help Not Setup",
    icon: /*#__PURE__*/React.createElement(PortalHelpIcon, {
      style: isHelpAvailable ? {
        pointerEvents: "none",
        color: "#fff"
      } : {}
    }),
    disabled: !isHelpAvailable
  }), /*#__PURE__*/React.createElement(PortalHelp, null));
};
export default PortalHelpHeaderItem;